import DefaultDetail from "./DefaultDetail";
export default {
  inject: ['i18n'],
  components: {
    DefaultDetail: DefaultDetail
  },
  props: {
    model: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    onChange: {
      type: Function,
      default: function _default() {}
    },
    readOnly: {
      type: Boolean,
      default: false
    },
    messageDefs: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  }
};